import type { Chat } from '@/types';
import { safeJsonDate } from './date';

export function transformChatFileUpload(data: Chat.FileUpload<string>): Chat.FileUpload {
  return {
    ...data,
    createdOn: safeJsonDate(data.createdOn),
  };
}